import { HandleLinkArgs } from '@display-component/shared';
import { useCallback } from 'react';

const useIframe = () => {
  const handleIframeAppLink = useCallback(
    (appLink?: HandleLinkArgs | undefined) => {
      appLink && window?.parent?.postMessage({ type: 'appLink', appLink }, '*');
    },
    [],
  );

  const handleIfrmaeLinkUrl = useCallback((link: string) => {
    window?.parent?.postMessage({ type: 'link', link }, '*');
  }, []);

  const isIframeLoaded = useCallback(
    () => window?.parent?.postMessage({ iframeLoaded: true }, '*'),
    [],
  );

  return { handleIframeAppLink, handleIfrmaeLinkUrl, isIframeLoaded };
};

export default useIframe;
